/* Timeline — click-and-drag panning, and hiding the hint once it has been used.
   Touch and trackpads already pan the overflow container natively; this exists
   for mouse users, who otherwise only have the scrollbar. */

(function () {
  function initSection(container) {
    if (!container) return;
    var root = container.querySelector('[data-bp-timeline]');
    if (!root) return;

    var viewport = root.querySelector('[data-bp-tl-viewport]');
    if (!viewport) return;

    var hint = root.querySelector('[data-bp-tl-hint]');

    /* The hint is advice, not state: once the reader has moved along the strip
       they have worked it out, and leaving it up is nagging. */
    function markSeen() {
      if (hint) hint.setAttribute('data-seen', 'true');
    }

    var moved = false;
    viewport.addEventListener('scroll', function () {
      if (!moved && viewport.scrollLeft > 24) {
        moved = true;
        markSeen();
      }
    }, { passive: true });

    /* Pointer events cover mouse and pen in one path. Touch is deliberately left
       to the browser: hijacking it breaks momentum scrolling. */
    var dragging = false;
    var startX = 0;
    var startScroll = 0;

    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      dragging = true;
      startX = event.clientX;
      startScroll = viewport.scrollLeft;
      viewport.setAttribute('data-dragging', 'true');
      viewport.setPointerCapture(event.pointerId);
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      event.preventDefault();
      viewport.scrollLeft = startScroll - (event.clientX - startX);
    });

    function endDrag(event) {
      if (!dragging) return;
      dragging = false;
      viewport.removeAttribute('data-dragging');
      if (event.pointerId !== undefined && viewport.hasPointerCapture(event.pointerId)) {
        viewport.releasePointerCapture(event.pointerId);
      }
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', endDrag);

    /* The viewport is focusable, so arrow keys have to move it or keyboard users
       reach a region they cannot pan. */
    viewport.addEventListener('keydown', function (event) {
      var step = viewport.clientWidth * 0.8;
      if (event.key === 'ArrowRight') {
        viewport.scrollLeft += step;
      } else if (event.key === 'ArrowLeft') {
        viewport.scrollLeft -= step;
      } else if (event.key === 'Home') {
        viewport.scrollLeft = 0;
      } else if (event.key === 'End') {
        viewport.scrollLeft = viewport.scrollWidth;
      } else {
        return;
      }
      event.preventDefault();
      markSeen();
    });
  }

  initSection(document.currentScript.parentElement);

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });
})();
